import request from "@/utils/request";


export function addStore(formData) {
    return request({
        url: '/wms/store/add',
        method: 'post',
        data: formData
    })
}

export function updateStore(formData) {
    return request({
        url: '/wms/store/update',
        method: 'post',
        data: formData
    })
}

export function queryStore(formData) {
    return request({
        url: '/wms/store/list',
        method: 'post',
        data: formData,
        headers: { repeatSubmit: false }
    })
}

/**
 * 仓库全量列表（不分页）。
 * 与 queryStore 的区别仅在于走后端的 /wms/store/all —— 后者不调用 startPage()，
 * 因此不会被默认 pageSize=10 截断。下拉、回显等字典场景统一用这个。
 */
export function queryStoreAll(formData) {
    return request({
        url: '/wms/store/all',
        method: 'post',
        data: formData,
        headers: { repeatSubmit: false }
    })
}

export function queryStoreInfo(formData) {
    return request({
        url: '/wms/store/query',
        method: 'post',
        data: formData
    })
}

export function storeType() {
    return request({
        url: '/config/sotre/type',
        method: 'get'
    })
}


export function storeState() {
    return request({
        url: '/config/sotre/states',
        method: 'get'
    })
}


export function addStorePart(formData) {
    return request({
        url: '/wms/storeset/add',
        method: 'post',
        data: formData
    })
}


//仓库配置的列表  比如分区列表  库位列表
export function queryPartType(formData) {
    return request({
        url: '/wms/storeset/list',
        method: 'post',
        data: formData,
        headers: { repeatSubmit: false }
    })
}

//查询单个数据信息
export function queryData(formData) {
    return request({
        url: '/wms/storeset/query',
        method: 'post',
        data: formData
    })
}


//分区类型
export function partitionType() {
    return request({
        url: '/config/sotre/partitiontype',
        method: 'get'
    })
}
// 生成入库单PDF，返回pdf访问路径（后端矢量PDF，优先生成，失败由前端兜底）
// 包含HTML渲染、PDF生成、OSS上传和数据库写入，不能使用普通接口的3秒超时。
export function generateInboundPdf(
    id,
    printStyle = 'inboundList',
    printSize = 'A4'
) {
    return request({
        url: '/inbound/generatePdf',
        method: 'get',
        params: {
            id,
            printStyle,
            printSize
        },
        timeout: 60000
    })
}



